<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">비방사전 관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>카테고리</p>
                <div class="form_select">
                  <b-form-select v-model="searchInfo.prescribe_category" >
                    <b-form-select-option value="">선택</b-form-select-option>
                    <b-form-select-option v-for="(item, index) in prescrbeCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                  </b-form-select>
                </div>
              </li>
              <li>
                <p>비방처방명</p>
                <input
                  type="text"
                  placeholder="입력하세요"
                  class="form_control"
                  v-model="searchInfo.prescribe_nm"
                />
              </li>
              <li>
                <p>등록자</p>
                <input
                  type="text"
                  placeholder="입력하세요"
                  class="form_control"
                  v-model="searchInfo.doctor_nm"
                />
              </li>
              <li>
                <p>신청일자</p>
                <Datepicker v-model="searchInfo.startDate" :defaultDate="searchInfo.startDate" :format="'YYYY-MM-DD'" />
                <span>~</span>
                <Datepicker v-model="searchInfo.endDate" :defaultDate="searchInfo.endDate" :format="'YYYY-MM-DD'"/>
              </li>
              
              <li>
                <p>처리상태</p>
                <div class="form_radio" >
                  <input type="radio" id="radio1" name="radio" value="" v-model="searchInfo.progress_status" />
                  <label for="radio1">전체</label>
                </div>
                <div  class="form_radio" v-for="(item, index) in progressStatusList" :key="index">
                  <input type="radio" :id="index" name="radio" :value="item.dtl_code" v-model="searchInfo.progress_status">
                  <label :for="index">{{item.dtl_code_nm}}</label>
                </div> 
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="list">
              <colgroup>
                <col width="150" />
                <col width="150" />
                <col width="*" />
                <col width="150" />
                <col width="150" />
                <col width="50" />
              </colgroup>
              <thead>
                <tr>
                  <th>신청일자</th>
                  <th>등록자</th>
                  <th>비방처방명</th>
                  <th>카테고리</th>
                  <th>상태</th>
                  <th>상세보기</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="scretPrescriptionList.length == 0">
                  <td colspan="5"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in scretPrescriptionList" :key="index">
                  <td>
                    <span>{{ item.reg_dt }}</span>
                  </td>
                  <td>
                    <span>{{ item.doctor_nm }}</span>
                  </td>
                  <td>
                    <span>{{ item.prescribe_nm }}</span>
                  </td>
                  <td>
                    <span>{{ item.prescribe_category_nm }}</span>
                  </td>
                  <td>
                    <span>{{ item.progress_status_nm }}</span>
                  </td>
                  <td>
                    <div class="flex justify-center">
                      <button class="bdge" @click="fn_move_dtl_page(item)">상세내용</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo"  @clickPage="fn_movePage" v-show="pagingShow"/>
          </div>
        </section>
      </div>
    </div>
</template>

<script>

import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import Pagination from "@/components/AdminPagination.vue";
import Datepicker from "@/components/Datepicker.vue";

export default {
  name: "AdminMain",
  components: {
    Pagination,
    Datepicker,
  },
  mixins: [commonUtil],
  data() {
    return {
      searchInfo : {
          doctor_nm : '',
          prescribe_nm : '',
          prescribe_category : '',
          startDate : '',
          endDate : '',
          progress_status : '',            
          pageInfo : {
              page : 1,
              pageSize : 10,
              totPage : 0
          }              
      },
      pagingShow : false,
      scretPrescriptionList: [],
      prescrbeCategoryList : [],
      progressStatusList : []
    };
  },
  async created(){

    //오늘 날짜구하기
    this.searchInfo.startDate =  this.getAddMonthDate(-3);
    this.searchInfo.endDate = this.getCurrentDate();

    //검색정보 처리
    let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             
    if(searchInfoStore != null && searchInfoStore != {}){
        this.searchInfo = searchInfoStore
    }

    //처방 카테고리
    this.prescrbeCategoryList = await this.getCode('GC00000015'); 
    this.progressStatusList = await this.getCode('GC00000016'); 
  },
  mounted(){     

      this.fn_search();
  },
  methods : {
    fn_search(){

          this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo); 

          axios
              .post("/api/admin/dictionary/getScretPrescriptionList", this.searchInfo)
              .then((res) => {
                  console.log("@@@@ res : %o",res);
                  this.scretPrescriptionList = res.data.scretPrescriptionList;

                  this.searchInfo.pageInfo.totPage = res.data.totCnt;
                  
                  if(this.searchInfo.pageInfo.totPage> 0){
                      this.pagingShow = true;                          
                  }                        

              })
              .catch((err) => console.log(err));
      },
      fn_movePage(page){
        this.searchInfo.pageInfo.page = page;
        this.fn_search();
      },
      fn_move_dtl_page(item){

        this.$store.dispatch('detailSearchInfo/setSearchInfo', item); 
        this.$router.push({ name : 'SecretPrescriptionMngtDetail'});
      },
  }
};
</script>
